import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import Moment from "moment";
import { meses } from "../../../services/data";
import { useSelector } from "react-redux";
import { connection_platform } from "../../../services/api";

import {
  Gallery,
  DocumentText,
  InfoCircle,
  Video,
  VoiceSquare,
  UserAdd,
  Location,
} from "iconsax-reactjs";
import urlIngWeb from "../../../actions/urlIngWeb";

export const useQueueItemMonitoring = (call, search) => {
  const Monitoring = useSelector((state) => state.monitoring);
  const tmnoreplyPerAgent = useSelector((state) => state.tmnoreplyPerAgent);
  const InfoUsers = useSelector((state) => state.informationusers);
  const messages = useSelector((state) => state.messages);
  // const tmnoreply = useMemo(() => {
  //   if (!Boolean(infoUsers)) {
  //     return undefined;
  //   }

  //   return infoUsers.tmnoreply;
  // }, [infoUsers]);
  const tmnoreply = useMemo(() => {
    const hasTmnoreplyPerAgent =
      Boolean(tmnoreplyPerAgent) &&
      Array.isArray(tmnoreplyPerAgent) &&
      tmnoreplyPerAgent.length > 0;
    if (!hasTmnoreplyPerAgent) {
      return 0;
    }
    const hasMonitoring =
      Boolean(Monitoring) &&
      (Boolean(Monitoring.userout) || Monitoring.userout === 0);
    if (!hasMonitoring) {
      return 0;
    }

    const tmnoreplyOfMonitoredAgent = tmnoreplyPerAgent.find(
      (agentInfo) =>
        parseInt(agentInfo.iduser) === parseInt(Monitoring.userout),
    );
    const hasTmnoreplyOfMonitoredAgent = Boolean(tmnoreplyOfMonitoredAgent);
    if (!hasTmnoreplyOfMonitoredAgent) {
      return 0;
    }

    return parseInt(tmnoreplyOfMonitoredAgent.tmnoreply) || 0;
  }, [tmnoreplyPerAgent, Monitoring]);

  const [lastMsg, setLastMsg] = useState("");
  const [msgIcon, setMsgIcon] = useState(<></>);
  const [classe, setClasse] = useState("");
  const [tempoExcedido, setTempoExcedido] = useState("");
  const [isOpenMoreOptions, setIsOpenMoreOptions] = useState(false);
  const callMessages = useMemo(() => {
    return messages[call.idatendimento] || undefined;
  }, [call && call.idatendimento, messages]);

  // const { classe, tempoExcedido } = useMemo(() => {
  //   let classe = "";
  //   let tempoExcedido = "";

  //   const msgs = callMessages;
  //   if (!msgs || msgs.length === 0 || tmnoreply <= 0) {
  //     return { classe, tempoExcedido };
  //   }
  //   const lastMsg = msgs[msgs.length - 1];
  //   const { dataenvio, destiny, author } = lastMsg;

  //   const isLastFromMe = author === "Me";

  //   const formatDate = Moment(dataenvio, "DD/MM/YYYY HH:mm:ss").format(
  //     "MM/DD/YYYY HH:mm:ss"
  //   );
  //   const diffDate = Moment().diff(formatDate, "seconds");

  //   if (diffDate >= tmnoreply) {
  //     if (destiny === "Gestor" && !isLastFromMe) {
  //       classe = "managerExpirated";
  //     } else if (destiny === "cliente" && !isLastFromMe) {
  //       classe = "clientExpirated";
  //     } else if (isLastFromMe) {
  //       classe = "operatorExpirated";
  //     }

  //     if (!isLastFromMe) {
  //       tempoExcedido = "excedido";
  //     }
  //   }

  //   return { classe, tempoExcedido };
  // }, [callMessages, tmnoreply]);

  const lastMessageInfo = useMemo(() => {
    return Boolean(messages) && Boolean(callMessages) && callMessages.length > 0
      ? callMessages[callMessages.length - 1]
      : {};
  }, [call, messages, callMessages]);
  const { formatted: lastInteractionLabel, destinomsg } = useMemo(() => {
    let lastDate = call.datatimeatd;
    let destinomsg = null;

    if (callMessages) {
      // const lastMsg = messages[call.idatendimento].at(-1);
      const lastMsg = lastMessageInfo ? lastMessageInfo : callMessages.at(-1);
      const hasData = !!lastMsg.dataenvio && lastMsg.dataenvio !== "undefined";

      if (hasData) {
        lastDate = lastMsg.dataenvio;
        destinomsg = lastMsg.destiny;
      } else {
        const { dia, anoenvio, datatime } = lastMsg || {};
        if (dia && anoenvio && datatime) {
          const arrDia = dia.split(" ");
          if (Array.isArray(arrDia) && arrDia.length >= 3) {
            const day = arrDia[0];
            const monthIndex = meses.indexOf(arrDia[2].toLowerCase());

            if (monthIndex >= 0 && monthIndex < 12) {
              const month = String(monthIndex + 1).padStart(2, "0");
              const dateString = `${day}/${month}/${anoenvio} ${datatime}`;
              lastDate = dateString;
            }
          }
        }
      }
    }

    const dateObj = Moment(lastDate, "DD/MM/YYYY HH:mm:ss");
    const now = Moment();

    const isToday = now.isSame(dateObj, "day");
    const isYesterday = now.clone().subtract(1, "day").isSame(dateObj, "day");

    if (isToday) {
      return { formatted: dateObj.format("HH:mm"), destinomsg };
    }

    if (isYesterday && destinomsg !== "Me") {
      return { formatted: "Ontem", destinomsg };
    }

    return { formatted: dateObj.format("DD/MM/YYYY"), destinomsg };
  }, [callMessages, lastMessageInfo]);

  // const getClassAndExcededTime = () => {
  //   let classe = "";
  //   let tempoExcedido = "";

  //   const msgs = callMessages;
  //   if (!msgs || msgs.length === 0 || tmnoreply <= 0) {
  //     return { classe, tempoExcedido };
  //   }
  //   const lastMsg = msgs[msgs.length - 1];
  //   const { dataenvio, destiny, author } = lastMsg;

  //   const isLastFromMe = author === "Me";
  //   console.log("raimundo_neto tempoExcedido 137", { isLastFromMe, lastMsg });
  //   const formatDate = Moment(dataenvio, "DD/MM/YYYY HH:mm:ss").format(
  //     "MM/DD/YYYY HH:mm:ss"
  //   );
  //   const diffDate = Moment().diff(formatDate, "seconds");

  //   if (diffDate >= tmnoreply) {
  //     if (destiny === "Gestor" && !isLastFromMe) {
  //       classe = "managerExpirated";
  //     } else if (destiny === "cliente" && !isLastFromMe) {
  //       classe = "clientExpirated";
  //     } else if (isLastFromMe) {
  //       classe = "operatorExpirated";
  //     }

  //     if (!isLastFromMe) {
  //       tempoExcedido = "excedido";
  //     } else {
  //       tempoExcedido = "";
  //     }
  //   }

  //   return { classe, tempoExcedido };
  // };
  const determineTypeName = (fileExtension, valueDefault) => {
    switch (fileExtension.toLowerCase()) {
      case "jpeg":
      case "png":
      case "webp":
      case "jpe":
      case "gif":
      case "bmp":
      case "jpg":
        return { type: "image", nameType: "Imagem" };
      case "pdf":
      case "zip":
      case "xls":
      case "xml":
      case "xlsx":
      case "xlsm":
      case "txt":
      case "doc":
      case "docx":
      case "ppt":
      case "pptx":
      case "ppsx":
        return { type: "document", nameType: "Arquivo" };
      case "wav":
      case "mp3":
      case "ogg":
      case "aac":
      case "m4a":
      case "amr":
      case "opus":
      case "mpeg":
        return { type: "audio", nameType: "Aúdio" };
      case "m4v":
      case "mp4":
        return { type: "video", nameType: "Vídeo" };
      default:
        return { type: "document", nameType: "Arquivo" };
    }
  };

  const getDurationAudio = async (url) => {
    return new Promise((resolve, reject) => {
      const audio = new Audio();
      audio.src = url;
      audio.addEventListener("loadedmetadata", () => {
        const duration = Math.floor(audio.duration);
        const mins = Math.floor(duration / 60)
          .toString()
          .padStart(2, "0");
        const secs = Math.floor(duration % 60)
          .toString()
          .padStart(2, "0");
        resolve(`${mins}:${secs}`);
      });
      audio.addEventListener("error", () => {
        resolve("Audio");
      });
    });
  };
  const getMatchingMessage = (atd, searchChats) => {
    const iconMap = {
      image: <Gallery variant="outline" color="#757575" />,
      video: <Video variant="outline" color="#757575" />,
      document: <DocumentText variant="outline" color="#757575" />,
      audio: <VoiceSquare variant="outline" color="#757575" />,
      contact: <UserAdd variant="outline" color="#757575" />,
      location: <Location variant="outline" color="#757575" />,
    };

    const search = searchChats.toLowerCase();

    if (!messages[atd.idatendimento]) return null;

    const allMsg = messages[atd.idatendimento];

    for (const msgs of allMsg) {
      let content = "";
      let icon = "";
      let hasError =
        msgs.statusmsg === "error" &&
        connection_platform.isStatusOfErrorInSendMessage;
      let iconError = <InfoCircle variant="Bold" color="#c90000" />;
      let messageInfos = {};

      switch (msgs.typemsg) {
        case "0": {
          content = msgs.message
            .replace(/¿/gi, "\n")
            .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
            .replaceAll("\n", "")
            .replaceAll('"}', "")
            .replaceAll("\\n", "")
            .replaceAll("\r", "")
            .replace(/_(.*?)_/g, "$1");

          if (content.toLowerCase().includes(search)) {
            return {
              lastMsg: content,
              msgIcon: hasError ? iconError : "",
              messageInfos: msgs,
              typeSearch: "search",
            };
          }
          break;
        }

        case "1": {
          const [thumbnail, captionRaw, url] = msgs.message.split("~¿");
          const cleanCaption = captionRaw ? captionRaw.trim() : captionRaw;
          const caption = (
            cleanCaption === "null" || !cleanCaption
              ? ""
              : cleanCaption.replace(/¿/gi, "")
          )
            .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
            .replaceAll("\n", "")
            .replaceAll('"}', "")
            .replaceAll("\\n", "")
            .replaceAll("\r", "")
            .replace(/_(.*?)_/g, "$1");

          if (url) {
            const [, extensionRaw] = url.split(".");
            const extension = extensionRaw ? extensionRaw.toLowerCase() : "";
            const { type } = determineTypeName(extension, "document");

            if (type !== "audio" && caption.toLowerCase().includes(search)) {
              icon = iconMap[type] || "";
              return {
                lastMsg: caption,
                msgIcon: hasError ? iconError : icon,
                messageInfos: msgs,
                typeSearch: "search",
              };
            }
          }
          break;
        }

        case "2": {
          const [rawText, url] = msgs.message
            .replace(/§/gi, "\r\n")
            .split("~¿");
          const caption = rawText
            .replace(/¿¿/gi, "")
            .replace(/¿/gi, "")
            .trim()
            .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
            .replaceAll("\n", "")
            .replaceAll('"}', "")
            .replaceAll("\\n", "")
            .replaceAll("\r", "")
            .replace(/_(.*?)_/g, "$1");

          if (url && url !== "null" && url !== "undefined") {
            const [, extensionRaw] = url.split(".");
            const extension = extensionRaw ? extensionRaw.toLowerCase() : "";
            const { type } = determineTypeName(extension, "document");

            if (type === "audio") break;
            if (caption.toLowerCase().includes(search)) {
              icon = iconMap[type] || "";
              return { lastMsg: caption, msgIcon: hasError ? iconError : icon };
            }
          } else {
            if (caption.toLowerCase().includes(search)) {
              return {
                lastMsg: caption,
                msgIcon: hasError ? iconError : "",
                messageInfos: msgs,
                typeSearch: "search",
              };
            }
          }

          break;
        }

        case "4": {
          const infos = msgs.message.split("~¿");
          const locationText = `${infos[1]} ${infos[0]}`.toLowerCase();

          if (locationText.includes(search)) {
            return {
              lastMsg: `${infos[1]} ${infos[0]}`,
              msgIcon: hasError ? iconError : iconMap["location"] || "",
              messageInfos: msgs,
              typeSearch: "search",
            };
          }
          break;
        }

        case "11": {
          try {
            const cleaned = msgs.message.replace(/\\(?!["\\/bfnrtu])/g, "");
            const contactInfo = JSON.parse(
              cleaned.replace(/(?<!\w)'|'(?!\w)/g, '"'),
            );
            const name = contactInfo.name.formatted_name;

            if (name.toLowerCase().includes(search)) {
              return {
                lastMsg: name,
                msgIcon: hasError ? iconError : iconMap["contact"] || "",
                messageInfos: msgs,
                typeSearch: "search",
              };
            }
          } catch (err) {
            console.error("Erro ao processar contato:", err);
          }
          break;
        }

        default:
          break;
      }
    }

    return null;
  };
  const getFormattedLastMessage = async (call, messages) => {
    let message = "";
    let msgIcon = "";
    let messageInfos = {};
    let typename = "";

    const iconMap = {
      image: <Gallery variant="outline" color="#757575" />,
      video: <Video variant="outline" color="#757575" />,
      document: <DocumentText variant="outline" color="#757575" />,
      audio: <VoiceSquare variant="outline" color="#757575" />,
      contact: <UserAdd variant="outline" color="#757575" />,
      location: <Location variant="outline" color="#757575" />,
    };

    const getIconAndMessageForMedia = async (lastMsg) => {
      const [thumbnail, captionRaw, url, size] = lastMsg.message.split("~¿");
      let cleanCaption = captionRaw ? captionRaw.trim() : captionRaw;
      let caption = (
        cleanCaption === "null" || !cleanCaption
          ? ""
          : captionRaw.replace(/¿/gi, "")
      )
        .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
        .replaceAll("\n", "")
        .replaceAll('"}', "")
        .replaceAll("\\n", "")
        .replaceAll("\r", "")
        .replace(/_(.*?)_/g, "$1");

      if (url) {
        const [pathWithoutExtension, extensionRaw] = url.split(".");
        const extension = extensionRaw ? extensionRaw.toLowerCase() : "";
        const { type, nameType } = determineTypeName(extension, "document");
        const fileName = `${pathWithoutExtension
          .split("/")
          .pop()}.${extension}`;

        const icon = iconMap[type] || "📎";
        const audioDuration =
          type === "audio"
            ? await getDurationAudio(`${urlIngWeb}${url}`)
            : null;

        return {
          message: type === "audio" ? audioDuration : caption || nameType,
          icon,
        };
      }

      return { message: caption, icon: "" };
    };

    if (messages[call.idatendimento]) {
      const lastMsg = messages[call.idatendimento].at(-1);
      messageInfos = lastMsg;

      // if (
      //   lastMsg.statusmsg === "error" &&
      //   connection_platform.isStatusOfErrorInSendMessage
      // ) {
      //   message = <i>Falha no envio da mensagem</i>;
      //   msgIcon = <InfoCircle variant="Bold" color="#c90000" />;
      // } else {
      switch (lastMsg.typemsg) {
        case "0":
          let mensagem_tratada = lastMsg.message.replace(/¿/gi, "\n");
          message = mensagem_tratada
            .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
            .replaceAll("\n", "")
            .replaceAll('"}', "")
            .replaceAll("\\n", "")
            .replaceAll("\n", "")
            .replaceAll("\\r", "")
            .replaceAll("\r", "")
            .replace(/_(.*?)_/g, "$1");
          break;

        case "1": {
          const result = await getIconAndMessageForMedia(lastMsg);
          message = result.message;
          msgIcon = result.icon;
          break;
        }

        case "2": {
          const [rawText, url] = lastMsg.message
            .replace(/§/gi, "\r\n")
            .split("~¿");
          const messageSeparada = rawText
            .replace(/¿¿/gi, "")
            .replace(/¿/gi, "")
            .trim();

          let icon = "";
          let fileName = "";
          let textSpan = "";

          if (url && url !== "null" && url !== "undefined") {
            const [pathWithoutExtension, extensionRaw] = url.split(".");
            const extension = extensionRaw ? extensionRaw.toLowerCase() : "";
            const { type, nameType } = determineTypeName(extension, "document");
            fileName = `${pathWithoutExtension.split("/").pop()}.${extension}`;
            icon = iconMap[type] || "📎";

            if (type === "audio") {
              message = await getDurationAudio(`${urlIngWeb}${url}`);
            } else {
              const editmsg = messageSeparada
                .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
                .replaceAll("\n", "")
                .replaceAll('"}', "")
                .replaceAll("\\n", "")
                .replaceAll("\r", "")
                .replace(/_(.*?)_/g, "$1");

              message = editmsg || nameType;
            }
          } else {
            const editmsg = messageSeparada
              .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
              .replaceAll("\n", "")
              .replaceAll('"}', "")
              .replaceAll("\\n", "")
              .replaceAll("\r", "")
              .replace(/_(.*?)_/g, "$1");

            message = editmsg;
          }

          msgIcon = icon;
          break;
        }

        case "4":
          let infosLocation = lastMsg.message.split("~¿");

          message = `${infosLocation[1]} ${infosLocation[0]}`;
          msgIcon = iconMap["location"] || "📎";
          break;

        case "11":
          const cleanedJsonString = lastMsg.message.replace(
            /\\(?!["\\/bfnrtu])/g,
            "",
          );
          const contactInfo = JSON.parse(
            cleanedJsonString.replace(/(?<!\w)'|'(?!\w)/g, '"'),
          );

          message = contactInfo.name.formatted_name;
          msgIcon = iconMap["contact"] || "📎";
          break;
        default:
          break;
      }
      // }
      if (
        lastMsg.statusmsg === "error" &&
        connection_platform.isStatusOfErrorInSendMessage &&
        lastMsg.typemon !== "2"
      ) {
        msgIcon = <InfoCircle variant="Bold" color="#c90000" />;
      }
    }

    // setLastMsg(message);
    // setMsgIcon(msgIcon);
    return {
      lastMsg: message,
      msgIcon,
      messageInfos,
    };
  };

  // useEffect(() => {
  //   getFormattedLastMessage(call, messages);
  // }, [call, messages]);

  useEffect(() => {
    let isMounted = true;

    const updateLastMessage = async () => {
      const clienteMatch = call.cliente.toLowerCase().includes(search);
      const telefoneMatch = call.telefone.toLowerCase().includes(search);
      // const telefoneMatch = call.telefone.toLowerCase().includes(search);
      let result;
      if (search && (clienteMatch || telefoneMatch)) {
        result = await getFormattedLastMessage(call, messages);
      } else if (search) {
        const found = getMatchingMessage(call, search);
        result = found || (await getFormattedLastMessage(call, messages));
      } else {
        result = await getFormattedLastMessage(call, messages);
      }
      if (isMounted) {
        setLastMsg(result.lastMsg);
        setMsgIcon(result.msgIcon);
      }
    };

    updateLastMessage();

    return () => {
      isMounted = false;
    };
  }, [call, JSON.stringify(lastMessageInfo), search]);

  const handleOpenMoreOptions = () => {
    setIsOpenMoreOptions(true);
  };
  const handleCloseMoreOptions = () => {
    setIsOpenMoreOptions(false);
  };
  const getIfIsFromAgent = (username, agent, author, typemon) => {
    if (username === agent) {
      return true;
    } else if (author !== "Me") {
      return false;
    } else if (author === "Gestor") {
      return false;
    } else if (typemon !== "0" && typemon !== "1") {
      return false;
    }
    return true;
  };

  const verifyIfIsMonitoringMessage = (isFromAAgent, selectedChat, message) => {
    let monitoringMessage = false;
    let nameUser = selectedChat.cliente;
    if (isFromAAgent || (message.typemon !== "0" && message.typemon !== "1")) {
      let username = message.username.toLowerCase();
      if (message.username) {
        nameUser =
          InfoUsers.username === message.username
            ? "Você"
            : username.includes("saída")
              ? selectedChat.cliente
              : message.username;
      } else {
        nameUser = "Você";
      }
    }

    if (!isFromAAgent && nameUser !== selectedChat.cliente) {
      monitoringMessage = true;
    }

    return monitoringMessage;
  };

  useEffect(() => {
    const getClassAndExcededTime = () => {
      let classe = "";
      let tempoExcedido = "";

      const msgs = callMessages;
      if (!msgs || msgs.length === 0 || tmnoreply <= 0) {
        return { classe, tempoExcedido };
      }
      const lastMsg = msgs[msgs.length - 1];
      const { dataenvio, destiny, author, typemon, username } = lastMsg;
      // const isLastFromMe = author === "Me"
      const isLastFromMe = getIfIsFromAgent(
        username,
        Monitoring.agent,
        author,
        typemon,
      );

      const formatDate = Moment(dataenvio, "DD/MM/YYYY HH:mm:ss").format(
        "MM/DD/YYYY HH:mm:ss",
      );
      const diffDate = Moment().diff(formatDate, "seconds");

      if (diffDate >= tmnoreply) {
        if (destiny === "Gestor" && !isLastFromMe) {
          classe = "managerExpirated";
        } else if (destiny === "cliente" && !isLastFromMe) {
          classe = "clientExpirated";
        } else if (isLastFromMe) {
          classe = "operatorExpirated";
        }

        const monitoringMessage = verifyIfIsMonitoringMessage(
          isLastFromMe,
          call,
          lastMsg,
        );
        const treatedTypemon = typemon
          ? monitoringMessage
            ? parseInt(typemon)
            : 1
          : parseInt(lastMsg.mon_type_id);
        const isFromAManager = treatedTypemon > 1;
        if (!isLastFromMe && !isFromAManager) {
          tempoExcedido = "excedido";
        } else {
          tempoExcedido = "";
        }
      }

      return { classe, tempoExcedido };
    };
    const interval = setInterval(() => {
      const { classe, tempoExcedido } = getClassAndExcededTime();
      setClasse(classe);
      setTempoExcedido(tempoExcedido);
    }, 1000);

    return () => clearInterval(interval);
  }, [callMessages, tmnoreply]);

  return {
    lastMsg,
    msgIcon,
    classe,
    tempoExcedido,
    lastMessageInfo,
    lastInteractionLabel,
    destinomsg,
    isOpenMoreOptions,
    handleCloseMoreOptions,
    handleOpenMoreOptions,
    getIfIsFromAgent,
    Monitoring,
    verifyIfIsMonitoringMessage,
  };
};
